<template>
  <v-dialog :value="value" persistent fullscreen>
    <v-card color="primary">
      <v-toolbar flat color="primary" class="mb-0" v-if="value">
        <h2>{{item.partner_id ? item.partner_id[1] : ""}} - {{item.name}}</h2>

        <v-spacer />
        <v-btn icon>
          <v-icon @click="$emit('input', false)">close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-layout
        column
        class="mt-2"
        :style="{ textAlign: 'center'}"
        v-if="currentStep === 1 && value"
      >
        <h2 class="mb-3">Products {{totalPrice ? `- ${totalPrice}` : ''}}</h2>
        <div
          class="primary lighten-1"
          :style="{width: '75%', height: '160px', overflow: 'scroll', margin: 'auto'}"
        >
          <div v-for="(product, index) in products" :key="index" :style="{maxWidth: '100%'}">
            <v-layout row nowrap>
              <v-flex>
                <h2 class="card-product-name">{{product.name}}</h2>
              </v-flex>
              <v-flex>
                <h2>{{product.qty}}</h2>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-layout>

      <v-layout
        column
        class="mt-2"
        :style="{ textAlign: 'center'}"
        v-if="currentStep === 2 && value"
      >
        <h2 class="mb-3">Signature Confirmation</h2>
        <div class="white signature-pad">
          <v-btn
            icon
            flat
            color="red"
            @click="$refs.signaturePad.clearSignature()"
            :style="{postion: 'absolute' }"
          >
            <v-icon medium>clear</v-icon>
          </v-btn>

          <VueSignaturePad
            :style="{marginTop: '-40px'}"
            :options="{onBegin: () => {$refs.signaturePad.resizeCanvas();}}"
            ref="signaturePad"
          ></VueSignaturePad>
        </div>

        <v-text-field
          class="center-items mt"
          v-model="confirmName"
          label="Print Name Here After Signing"
          color="secondary"
          box
        />
      </v-layout>

      <v-layout
        column
        class="mt-2"
        :style="{ textAlign: 'center'}"
        v-if="currentStep === 3 && value"
      >
        <h2 class="mb-3">Extra Information</h2>
        <div :style="{width: '75%', margin: 'auto', textAlign: 'right'}">
          <v-card-text>
            <v-text-field
              class="center-items"
              v-model="checkNumber"
              label="Check # "
              color="secondary"
              box
            />

            <v-text-field
              class="center-items"
              v-model="notes"
              label="Issues or Notes"
              color="secondary"
              box
            />
            <v-radio-group
              label="Product Correct?"
              v-model="correctProduct"
              row
              class="center-items"
            >
              <v-radio label="Yes" color="secondary lighten-1" :value="true" />
              <v-radio label="No" color="secondary lighten-1" :value="false" />
            </v-radio-group>

            <v-radio-group
              label="Pickup or Delivery?"
              v-model="pickupOrDelivery"
              row
              class="center-items"
            >
              <v-radio label="Pickup" color="secondary lighten-1" value="Pickup" />
              <v-radio label="Delivery" color="secondary lighten-1" value="Delivery" />
            </v-radio-group>
          </v-card-text>
        </div>
      </v-layout>

      <v-card-actions class="justify-center mt-2" v-if="value">
        <v-btn
          class="card-buttons"
          @click="currentStep === 1 ? $emit('input', false) : currentStep-- "
        >{{currentStep === 1 ? 'Cancel' : 'Go Back'}}</v-btn>
        <v-btn
          class="card-buttons"
          :color="currentStep < 3 ? 'secondary lighten-1' : 'success'"
          @click="handleContinue()"
        >{{currentStep &lt; 3 ? 'Continue' : 'Confirm'}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "wholesale-signin",
  props: ["value", "item"],
  data() {
    return {
      products: [],
      currentStep: 1,
      confirmName: "",
      checkNumber: "",
      notes: "",
      pickupOrDelivery: "",
      correctProduct: "",
      signature: "",
      locationURL: ""
    };
  },
  watch: {
    item: {
      handler(val) {
        if (val.move_lines) {
          val.move_lines.forEach(async moveID => {
            await this.moveSearch([
              {
                field: "id",
                operator: "=",
                value: moveID
              }
            ]);
            this.addProduct(
              this.stockMove[0].name,
              this.stockMove[0].ordered_qty
            );
          });
        }
        if (val.sale_id) {
          this.saleOrderSearch([
            {
              field: "id",
              operator: "=",
              value: val.sale_id[0]
            }
          ]);
        }
      },
      deep: true
    },
    value(val) {
      if (!val) this.reset();
      else this.currentPosition();
    }
  },
  computed: {
    ...mapGetters({
      stockMove: "stockMove/getMove",
      user: "app/getUser",
      saleOrder: "order/getOrders"
    }),
    totalPrice() {
      if (this.saleOrder[0])
        return `$${this.saleOrder[0].amount_total.toLocaleString()}`;
      else return "";
    }
  },
  methods: {
    ...mapActions({
      moveSearch: "stockMove/search",
      setSnackbar: "app/setSnackbar",
      postMessageToChatter: "picking/postMessageToChatter",
      pickingSearch: "picking/search",
      validatePicking: "picking/validatePicking",
      saleOrderSearch: "order/search"
    }),
    addProduct(name, qty) {
      this.products.push({
        name,
        qty
      });
    },
    handleContinue() {
      switch (this.currentStep) {
        case 1:
          this.currentStep++;
          break;
        case 2:
          this.confirmSignature();
          break;
        default:
          this.submitPickup();
          break;
      }
    },
    confirmSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (this.confirmName !== "" && !isEmpty) {
        this.signature = data;
        this.currentStep++;
      } else
        this.setSnackbar({
          text: "Please confirm that you signed and printed your name.",
          color: "red"
        });
    },
    async submitPickup() {
      let validate = { success: false };

      if (this.pickupOrDelivery !== "") {
        if (this.correctProduct) {
          validate = await this.validatePicking({
            id: this.item.id
          });
        }

        if (validate.success || this.correctProduct === false) {
          this.postMessageToChatter({
            id: this.item.id,
            message: await this.getMessage()
          });
          this.pickingSearch([
            {
              field: "picking_type_id",
              operator: "in",
              value: [23, 12]
            },
            {
              field: "state",
              operator: "=",
              value: "assigned"
            }
          ]);
          this.$emit("input", false);
        } else {
          this.setSnackbar({
            text: validate.error,
            color: "red"
          });

          this.postMessageToChatter({
            id: this.item.id,
            message: `<h4 style="color: red;">${validate.error}</h4>`
          });
        }
      } else
        this.setSnackbar({
          text: "Please select pickup or delivery",
          color: "red"
        });
    },
    async currentPosition() {
      if (navigator.geolocation) {
        await navigator.geolocation.getCurrentPosition(
          position => {
            let long = position.coords.longitude;
            let lat = position.coords.latitude;
            this.locationURL = `https://maps.google.com?q=${lat},${long}`;
          },
          () => {},
          {
            enableHighAccuracy: true
          }
        );
      }
    },
    async getMessage() {
      return `<h4>Order <strong>
      ${this.pickupOrDelivery === "Pickup" ? "Picked up" : "Delivered"}
      </strong > ${this.pickupOrDelivery === "Pickup" ? " by" : " to"} 
      <strong>${this.confirmName}</strong> 
      ${
        this.locationURL
          ? ` at <a href="${this.locationURL}" target="_blank"> Location </a> </h4>`
          : ""
      }
        <div>
          ${this.checkNumber ? `<h5>Check #: ${this.checkNumber} </h5>` : ""}
          ${this.notes ? `<h5>Notes: ${this.notes} </h5>` : ""}
        </div>
        <div> 
          <h5 style='text-align: center;'>Signature: </h5>
          <img style='background-color: white' src='${this.signature}' />
        </div>
      `;
    },
    reset() {
      this.products = [];
      this.currentStep = 1;
      this.confirmName = "";
      this.checkNumber = "";
      this.notes = "";
      this.pickupOrDelivery = "";
      this.correctProduct = "";
      this.locationURL = "";
      this.$store.commit("order/setOrders", []);
    }
  }
};
</script>

<style scoped>
.card-product-name {
  width: 50vw;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.signature-pad {
  width: 75%;
  height: 160px;
  overflow: hidden;
  margin: auto;
  text-align: right;
}
.center-items {
  width: 75%;
  margin: auto;
}
.card-buttons {
  width: 15%;
  height: 40px;
}
</style>